import { OMSMetricsRequestSchema } from "@redotech/redo-fulfillment-common/metrics";
import * as z from "zod";

export const getWorkOrderItemsCompletedByProduct = {
  name: "getWorkOrderItemsCompletedByProduct" as const,
  input: OMSMetricsRequestSchema,
  output: z.object({
    outputProducts: z.array(
      z.object({
        productName: z.string(),
        sku: z.string().nullish(),
        items: z.number(),
      }),
    ),
    itemsWithoutBom: z.number(),
  }),
};
